import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { useStore } from '../../app/data/root.store';
import { MAX_VAULT_FILE_SIZE_MB, SUPPORTED_FILE_FORMATS } from '../component/Vault.const';

export const useVaultDropzone = (openUpload) => {
    const { vaultStore, userStore, billingStore, uiStore } = useStore();

    const onDrop = useCallback(async (acceptedFiles, rejectedFiles) => {
        if (userStore.isActionBlockedByRole('addVaultFile')) {
            userStore.setShowLimitedSharedAccess(true);
            return;
        }

        if (userStore.isDemoOrReadOnlyMode) {
            if (userStore.isDemoMode) {
                billingStore.setShowPricingTableModal(true);
            } else {
                uiStore.setShowDemoLimitationModal(true);
            }
            return;
        }

        openUpload?.(acceptedFiles, false);
    }, [userStore, billingStore, uiStore, openUpload]);

    const maxSizeInBytes = (MAX_VAULT_FILE_SIZE_MB * (2 ** 20));
    const isDropzoneDisabled = vaultStore.isUploading;
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        maxSize: maxSizeInBytes,
        accept: SUPPORTED_FILE_FORMATS,
        disabled: isDropzoneDisabled,
        noClick: true,
        noKeyboard: isDropzoneDisabled
    });

    return {
        getRootProps,
        getInputProps,
        isDragActive,
        isDropzoneDisabled
    };
}; 